<template>
  <transition name="slide-locked">
    <div
      class="match-bets"
      :key="'standard-1'"
      v-if="matchBettingStatus">
      <match-bet
        v-for="matchBet in matchBets"
        :key="matchBet.id"
        :match-bet="matchBet"
        :match-row-template="matchRowTemplate"
        :increase-odd-size="true"
      />
    </div>
    <match-locked
      :match-status-period="matchStatusPeriod"
      :key="'standard-2'"
      v-else
    />
  </transition>
</template>

<script>
import MatchBet from '@/components/common/match-bet/MatchBet.vue';
import MatchLocked from '@/components/common/match-locked/MatchLocked.vue';

export default {
  name: 'MatchBets',
  components: {
    MatchBet,
    MatchLocked,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      matchRowTemplate: 'Standard',
    };
  },
  computed: {
    matchBettingStatus() {
      return this.$store.getters.getMatchBettingStatus(this.idMatch);
    },
    matchStatusPeriod() {
      return this.$store.getters.getMatchStatusPeriod(this.idMatch);
    },
    matchBets() {
      return this.$store.getters.getSportMatchBets(this.idMatch);
    },
  },
};
</script>

<style lang="scss" scoped>
.match-bets {
  overflow: hidden;
}
</style>
